import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';
import LogoImage from '../../../assets/logo.png';
import PaymentStatus from '../payment_status';

function GuestJobDetailPage() {
  const { id: referenceId } = useParams();

  return (
    <Box sx={{ width: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          paddingY: '8px',
        }}
      >
        <Box component="img" src={LogoImage} sx={{ objectFit: 'cover' }} />
      </Box>
      <Box sx={{ marginTop: 8 }}>
        <PaymentStatus referenceId={referenceId || ''} />
      </Box>
    </Box>
  );
}

export default GuestJobDetailPage;
